module.exports = __webpack_public_path__ + "static/media/online1.dba525b4.svg";